import { render, staticRenderFns } from "./PortalDesignerDialog.vue?vue&type=template&id=5903698e&scoped=true&"
import script from "./PortalDesignerDialog.vue?vue&type=script&lang=js&"
export * from "./PortalDesignerDialog.vue?vue&type=script&lang=js&"
import style0 from "./PortalDesignerDialog.vue?vue&type=style&index=0&id=5903698e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5903698e",
  null
  
)

export default component.exports